<div class="last-client-property-label client-property-label">
	@if (isBillingContact) {
		<span>{{ 'contact-person.billing-label' | translate }}</span>
	}
	@if (!isBillingContact) {
		<span>{{ 'contact-person.label' | translate }}</span>
	}
	<change-label [visible]="isContactPersonChanged()" [changeSet]="changeSet"></change-label>
</div>
<div id="contact-person" class="client-property-contact-person">
	<div>{{ contactPersonDetails }}</div>
</div>
<div id="job-title" class="client-property-contact-person">
	<div>{{ jobTitle }}</div>
</div>
<div id="email" class="client-property-contact-person">
	<div>{{ email }}</div>
</div>
<div id="phone-number" class="client-property-contact-person">
	<div>{{ phoneNumber }}</div>
</div>

@if (salesperson) {
	<div>
		<div class="last-client-property-label client-property-label">
			<span>{{ 'contact-person.sales-person' | translate }}</span>
			<change-label [visible]="isSalespersonChanged()" [changeSet]="changeSet"></change-label>
		</div>
		<div id="salesperson" class="client-property-contact-person">
			<div>{{ salesperson }}</div>
		</div>
	</div>
}
